import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

type GetOauthRedirectParamsType = { managedIntegrationUuid: string };
type GetOAuthRedirectQueryKey = readonly [
  'fusion',
  'oauth',
  GetOauthRedirectParamsType,
];
type GetOAuthRedirectResponse = {
  redirectUrl: string;
};

export const useGetOAuthRedirect: QueryFunction<
  GetOAuthRedirectResponse,
  [GetOauthRedirectParamsType],
  GetOAuthRedirectQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey: GetOAuthRedirectQueryKey = ['fusion', 'oauth', params];
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/integrations/fusion/${params.managedIntegrationUuid}/oauth`, {
        init: {
          signal,
        },
      }),
  });
};
